module.exports = __webpack_public_path__ + "static/media/image_1.9ad9b7f9.png";